import { UrlConstants } from "../url.constants";
export class ApiExternalLinksConstants {
    static URL_SURVEY_LINKS = UrlConstants.API_V2 + "EditableSurvey/GetEditableSurveyLinks";
    static URL_ARCGIS_ITEMS = UrlConstants.API_V2 + "ArcGISItem";
}
